document.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector("[data-pp2-ritual-finder]");
  if (!root) return;

  const products = {
    vitalizer: {
      ritual: "Het waterritueel", name: "Phipower Watervitalizer 2 liter",
      why: "Je antwoorden wijzen naar een langzaam, zintuiglijk moment dat je elke dag kunt herhalen — en water is de gewoonte die je al hebt. De Vitalizer maakt er iets van om naar uit te kijken.",
      points: ["Instelbare 500–3000 rpm vortex in handgemaakt borosilicaatglas", "Vier LED-golflengtes en de Lotus of Life-projectie", "Golden Triangle-kristallen, geen filters of cartridges"],
      href: "/nl/products/water-vitalizer-2-0", image: "phipower-water-vitalizer-pouring.webp",
      alt: "Watervitalizer 1,6 liter", altHref: "/nl/products/water-vitalizer-1-6"
    },
    hydrogenPortable: {
      ritual: "Het waterstofmoment", name: "Phipower Waterstoffles 6.000 ppb",
      why: "Je wilt iets snels, meetbaars en draagbaars. Vullen, één keer drukken, en vijf minuten later is je waterstofrijke water klaar — aan je bureau, na training of onderweg.",
      points: ["PEM/SPE-elektrolyse, tot 6000 ppb", "Een complete cyclus in ongeveer vijf minuten", "Inhalatie-accessoire inbegrepen in de set"],
      href: "/nl/products/hydrogen-water-bottle-6000-ppb", image: "phipower-hydrogen-4-drinking.jpg",
      alt: "Phipower Waterstofinhalator", altHref: "/nl/products/hydrogen-inhaler"
    },
    hydrogenDeep: {
      ritual: "Het diepe waterstofritueel", name: "Phipower Waterstofinhalator",
      why: "Je bent klaar voor een sessie in plaats van een snelle gewoonte — tijd waarvoor je gaat zitten. Dit is de keus als waterstof onderdeel wordt van je wellnessruimte in plaats van een af en toe experiment.",
      points: ["666 ml waterstof en 333 ml zuurstof per minuut", "Digitale bediening, timers en TDS-monitoring", "Gebouwd voor langere sessies thuis of professioneel"],
      href: "/nl/products/hydrogen-inhaler", image: "phipower-hydrogen-6-inhaling.jpg",
      alt: "Phipower Waterstoffles 6.000 ppb", altHref: "/nl/products/hydrogen-water-bottle-6000-ppb"
    },
    lamp: {
      ritual: "Het lichtritueel", name: "Phipower 200W Red Light Therapy Lamp",
      why: "Je wilt een ritueel dat je bijna niets vraagt. Aanzetten, de timer op 10, 15 of 20 minuten zetten en lezen, ontspannen of nietsdoen terwijl hij loopt.",
      points: ["40 LEDs die 660 nm rood en 850 nm nabij-infrarood combineren", "Gericht gebruik: gezicht, schouders, knieën, handen of voeten", "Compact genoeg voor een bureau of nachtkastje"],
      href: "/nl/products/red-light-therapy-lamp-200w", image: "phipower-red-light-lamp-1-lifestyle.jpg",
      alt: "1500W Full-Body Panel", altHref: "/nl/products/red-light-therapy-panel-1500w"
    },
    panel: {
      ritual: "Het lichtritueel", name: "Phipower 1500W Full-Body Panel",
      why: "Je wilt een echte sessie en brede dekking in plaats van een klein lampje verplaatsen. Ga voor het paneel staan en maak licht een volledig onderdeel van je routine.",
      points: ["300 LEDs over een oppervlak van ca. 89 × 28 cm", "Aparte kanalen voor rood en nabij-infrarood", "Voor toegewijde wellnessruimtes, frequente training en studios"],
      href: "/nl/products/red-light-therapy-panel-1500w", image: "phipower-red-light-panel-1-lifestyle.jpeg",
      alt: "200W Red Light Lamp", altHref: "/nl/products/red-light-therapy-lamp-200w"
    },
    rephiro: {
      ritual: "De frequentiepauze", name: "Rephiro Bioharmonizer",
      why: "Frequenties fascineren je, maar software, frequentielijsten of programmeren laten je koud. Eén knop, één voor ingestelde cyclus van ongeveer 5,5 minuten — het makkelijkste ritueel om in een dag te passen die je al hebt.",
      points: ["Op Rife geïnspireerde technologie in een apparaat van 105 gram", "Eén knop, geen laptop en geen leercurve", "Een complete sessie in ruwweg 5,5 minuten"],
      href: "/nl/products/rephiro-bioharmonizer-rife-machine", image: "phipower-rephiro-ritual-lifestyle.jpg",
      alt: "Meditation Pyramid", altHref: "/nl/products/meditation-pyramid"
    },
    pyramid: {
      ritual: "Het stilte-ritueel", name: "Phipower Meditation Pyramid",
      why: "Je hebt geen nieuw apparaat nodig — je hebt een plek nodig. Een fysieke grens rond je beoefening maakt de overgang van alledag naar stilte verrassend makkelijk.",
      points: ["Geïnspireerd op de geschatte 51,83° Giza-geometrie", "Eén set, twee formaten: 140 cm large of 77 cm medium", "Inclusief amethisten orgonietbol"],
      href: "/nl/products/meditation-pyramid", image: "phipower-meditation-pyramid.jpg",
      alt: "Rephiro Bioharmonizer", altHref: "/nl/products/rephiro-bioharmonizer-rife-machine"
    },
    ionizer: {
      ritual: "Het alledaagse waterritueel", name: "Phipower Waterionizer",
      why: "Jouw prioriteit is praktisch: beter water gedurende de hele dag in plaats van één bereide karaf. Eén apparaat in de keuken, zeven kiesbare standen.",
      points: ["Geïntegreerd actief-koolfilter", "Vier alkalische, één neutrale en twee zure standen", "Voor drinken, koken en huishoudelijke routines"],
      href: "/nl/products/alkaline-water-ionizer", image: "phipower-ionizer-ritual-lifestyle.jpg",
      alt: "Watervitalizer 2 liter", altHref: "/nl/products/water-vitalizer-2-0"
    }
  };

  const questions = [
    { q: "Wanneer wil je het graag een nieuwe gewoonte maken?", options: [
      { label: "Als eerste in de ochtend", hint: "Vóór de dag het overneemt", w: { vitalizer: 3, hydrogenPortable: 2, ionizer: 1 } },
      { label: "Ergens midden op de dag", hint: "Tussen vergaderingen, na training", w: { hydrogenPortable: 3, rephiro: 2, ionizer: 2 } },
      { label: "'s Avonds", hint: "Afronden, telefoon weg", w: { lamp: 3, rephiro: 2, pyramid: 2 } },
      { label: "De hele dag, op de achtergrond", hint: "Beter water wanneer ik er ook naar reik", w: { ionizer: 3, vitalizer: 1 } }
    ] },
    { q: "Hoeveel tijd geef je er realistisch?", options: [
      { label: "Vijf minuten", hint: "Kort en herhaalbaar", w: { hydrogenPortable: 3, rephiro: 3, ionizer: 2 } },
      { label: "Tien tot twintig minuten", hint: "Lang genoeg om als pauze te voelen", w: { vitalizer: 3, lamp: 3, rephiro: 1 } },
      { label: "Een echte sessie", hint: "Ik ga zitten en blijf", w: { hydrogenDeep: 3, panel: 3, pyramid: 3 } }
    ] },
    { q: "Wat trekt je het meest aan?", options: [
      { label: "Water, beweging en licht", hint: "Vortex, kristallen, geometrie", w: { vitalizer: 3, ionizer: 1 } },
      { label: "Meetbare technologie", hint: "Waterstof in ppb, output per minuut", w: { hydrogenPortable: 3, hydrogenDeep: 3, ionizer: 1 } },
      { label: "Licht op mijn lichaam", hint: "Rood en nabij-infrarood", w: { lamp: 3, panel: 3 } },
      { label: "Frequenties en stilte", hint: "Stille minuten, aandacht naar binnen", w: { rephiro: 3, pyramid: 3 } }
    ] },
    { q: "Waar gaat hij wonen?", options: [
      { label: "Op het aanrecht", hint: "Onderdeel van het dagelijks leven", w: { vitalizer: 3, ionizer: 3 } },
      { label: "In mijn tas", hint: "Hij reist met me mee", w: { hydrogenPortable: 3, rephiro: 2 } },
      { label: "Aan mijn bureau of bed", hint: "Waar ik toch al zit", w: { lamp: 3, rephiro: 2 } },
      { label: "In een eigen wellnessruimte", hint: "Een eigen kamer of hoek", w: { panel: 3, hydrogenDeep: 3, pyramid: 3 } }
    ] }
  ];

  const imageUrls = window.__ppRitualImages || {};
  const state = { step: 0, picks: [], forced: null };

  const urlKey = new URLSearchParams(location.search).get("ritual");
  if (urlKey && products[urlKey]) {
    state.forced = urlKey;
    state.step = questions.length;
  }

  const questionPane = root.querySelector("[data-pp2-rf-question]");
  const resultPane = root.querySelector("[data-pp2-rf-result]");
  const stepLabelEl = root.querySelector("[data-pp2-rf-step-label]");
  const progressBarEl = root.querySelector("[data-pp2-rf-progress-bar]");
  const questionEl = root.querySelector("[data-pp2-rf-question-text]");
  const optionsEl = root.querySelector("[data-pp2-rf-options]");
  const backBtn = root.querySelector("[data-pp2-rf-back]");
  const resetBtns = root.querySelectorAll("[data-pp2-rf-reset]");

  function score() {
    const totals = {};
    state.picks.forEach((w) => {
      Object.keys(w).forEach((k) => { totals[k] = (totals[k] || 0) + w[k]; });
    });
    let best = "vitalizer", bestScore = -1;
    Object.keys(totals).forEach((k) => { if (totals[k] > bestScore) { bestScore = totals[k]; best = k; } });
    return { key: best, ...products[best] };
  }

  function pick(weights) {
    state.picks = state.picks.slice(0, state.step).concat([weights]);
    state.step += 1;
    render();
  }

  function back() {
    state.step = Math.max(0, state.step - 1);
    render();
  }

  function reset() {
    state.step = 0;
    state.picks = [];
    state.forced = null;
    render();
  }

  function doShare(result) {
    const url = location.origin + location.pathname + "?ritual=" + result.key;
    const text = "Mijn Phipower-ritueel is " + result.ritual + " (" + result.name + "). Vind het jouwe in 60 seconden:"
    if (navigator.share) {
      navigator.share({ title: "Mijn Phipower-ritueel", text: text, url: url }).catch(function () {});
    } else if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text + " " + url).then(function () {
        const btn = root.querySelector("[data-pp2-rf-share]");
        btn.textContent = "Link gekopieerd ✓";
        setTimeout(function () { btn.textContent = "Deel je ritueel ↗"; }, 2200);
      });
    }
  }

  function render() {
    const total = questions.length;
    const done = state.step >= total;

    if (done) {
      questionPane.hidden = true;
      resultPane.hidden = false;
      const result = state.forced ? { key: state.forced, ...products[state.forced] } : score();
      const shareBtn = root.querySelector("[data-pp2-rf-share]");
      if (shareBtn) { shareBtn.onclick = function () { doShare(result); }; }
      resultPane.querySelector("[data-pp2-rf-result-ritual]").textContent = "Jouw ritueel · " + result.ritual;
      resultPane.querySelector("[data-pp2-rf-result-name]").textContent = result.name;
      resultPane.querySelector("[data-pp2-rf-result-why]").textContent = result.why;
      const pointsEl = resultPane.querySelector("[data-pp2-rf-result-points]");
      pointsEl.innerHTML = "";
      result.points.forEach((p) => {
        const span = document.createElement("span");
        span.textContent = "✓ " + p;
        pointsEl.appendChild(span);
      });
      const cta = resultPane.querySelector("[data-pp2-rf-result-cta]");
      cta.href = result.href;
      const altLink = resultPane.querySelector("[data-pp2-rf-result-alt]");
      altLink.href = result.altHref;
      altLink.textContent = result.alt;
      const img = resultPane.querySelector("[data-pp2-rf-result-image]");
      img.src = imageUrls[result.image] || "";
      img.alt = result.name;
      return;
    }

    questionPane.hidden = false;
    resultPane.hidden = true;
    const q = questions[state.step];
    stepLabelEl.textContent = "Vraag " + (state.step + 1) + " van " + total;
    progressBarEl.style.width = Math.round((state.step / total) * 100) + "%";
    questionEl.textContent = q.q;
    optionsEl.innerHTML = "";
    q.options.forEach((opt) => {
      const btn = document.createElement("button");
      btn.className = "pp2-rf-option";
      btn.type = "button";
      btn.innerHTML = '<span class="pp2-rf-option-label">' + opt.label + '</span><span class="pp2-rf-option-hint">' + opt.hint + "</span>";
      btn.addEventListener("click", () => pick(opt.w));
      optionsEl.appendChild(btn);
    });
    backBtn.style.pointerEvents = state.step === 0 ? "none" : "auto";
    backBtn.style.color = state.step === 0 ? "rgba(255,255,255,.25)" : "rgba(255,255,255,.7)";
  }

  backBtn.addEventListener("click", back);
  resetBtns.forEach((btn) => btn.addEventListener("click", reset));

  render();
});
